module.exports = __webpack_public_path__ + "img/kfc.40d89307.png";